import { render, staticRenderFns } from "./Merchandiser.vue?vue&type=template&id=5e26f55f"
import script from "./Merchandiser.vue?vue&type=script&lang=js"
export * from "./Merchandiser.vue?vue&type=script&lang=js"
import style0 from "./Merchandiser.vue?vue&type=style&index=0&id=5e26f55f&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports